// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__1JiQt","trigger":"Tabs_trigger__Scgba","translate":"Tabs_translate__8ejzG"};